"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLogLevel = exports.logLevels = exports.LogLevel = void 0;
var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["SPECIAL"] = 0] = "SPECIAL";
    /** Important System status messages, always log - to be used to flag valid but notable events */
    LogLevel[LogLevel["SYSTEM"] = 1] = "SYSTEM";
    LogLevel[LogLevel["TRACE"] = 2] = "TRACE";
    LogLevel[LogLevel["DEBUG"] = 3] = "DEBUG";
    LogLevel[LogLevel["INFO"] = 4] = "INFO";
    LogLevel[LogLevel["WARN"] = 5] = "WARN";
    LogLevel[LogLevel["ERROR"] = 6] = "ERROR";
    LogLevel[LogLevel["FATAL"] = 7] = "FATAL";
})(LogLevel || (exports.LogLevel = LogLevel = {}));
exports.logLevels = ['SPECIAL', 'SYSTEM', 'TRACE', 'DEBUG', 'INFO', 'WARN', 'ERROR', 'FATAL',];
const isLogLevel = (level) => {
    return typeof level === 'string' && exports.logLevels.includes(level);
};
exports.isLogLevel = isLogLevel;
